// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"9010338c","796":"44d8f97f"}[chunkId] + ".chunk.js";
};